import { SubjectData } from 'shell/models/person';
import { AccordionOtherCitizenship as OtherCitizenshipVM } from 'shell/view-models/accordion-other-citizenship';
import { DateTime } from 'luxon';

export const transformOtherCitizenship = (person: SubjectData): OtherCitizenshipVM | undefined => {
  const originReturnData: OtherCitizenshipVM | undefined = person.altraCittadinanza
    ? {
        state: person.altraCittadinanza?.codiceStato || '',
        validFrom: person.altraCittadinanza?.dataValidita
          ? DateTime.fromISO(person.altraCittadinanza?.dataValidita)
          : null,
        descriptionState: person.altraCittadinanza?.descrizioneStato || '',
        note: person.altraCittadinanza?.noteStato || '',
      }
    : undefined;

  return originReturnData;
};
